import { httpsCallable } from "firebase/functions";
import { functions, FunctionResponse } from "./app";
import { Id } from "../types";

const remoteToggleFriend = httpsCallable(functions, "toggleFriend");

export async function toggleFriend(
  friendId: Id,
  linked: boolean,
): Promise<FunctionResponse> {
  const result = await remoteToggleFriend({ friend_id: friendId, linked });

  return result.data as FunctionResponse;
}
